import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const changeTrainingFollowUpEndDate = createApiThunk<void, { trainingFollowUpId: string; endDate: Date }>(
  "trainingFollowUps/changeTrainingFollowUpEndDate",
  async ({ trainingFollowUpId, endDate }, { extra: { adminRepository } }) => {
    return adminRepository!.changeTrainingFollowUpEndDate({ trainingFollowUpId, endDate });
  },
);

export const resetChangeTrainingFollowUpEndDate = createAction("admin/resetChangeTrainingFollowUpEndDate");
